namespace RioERP.Web.Enums {
    export enum Currency {
        INR = 1
    }
    Serenity.Decorators.registerEnumType(Currency, 'RioERP.Web.Enums.Currency');
}
